import React, { useEffect, useState } from 'react';
import './Responsive.css';

function App() {
  const [domains, setDomains] = useState([]);
  const [query, setQuery] = useState('');
  const [result, setResult] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [expandedAnime, setExpandedAnime] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [gearOpen, setGearOpen] = useState(false);

  useEffect(() => {
    fetch('/domains.json')
      .then(res => res.json())
      .then(setDomains);
  }, []);

  const handleSearch = () => {
    const found = domains.find(d => d.domain.toLowerCase() === query.toLowerCase());
    setResult(found || 'not found');
    setSuggestions([]);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value.length > 0) {
      const filtered = domains.filter(d =>
        d.domain.toLowerCase().startsWith(value.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  const handleSuggestionClick = (domainObj) => {
    setQuery(domainObj.domain);
    setSuggestions([]);
    setResult(domainObj);
  };

  const toggleAnime = (anime) => {
    setExpandedAnime(prev => ({ ...prev, [anime]: !prev[anime] }));
  };

  const groupedByAnime = domains.reduce((acc, d) => {
    const origins = Array.isArray(d.origin) ? d.origin : [d.origin];
    origins.forEach(origin => {
      acc[origin] = acc[origin] || [];
      acc[origin].push(d);
    });
    return acc;
  }, {});

  const groupedByCategory = domains.reduce((acc, d) => {
    acc[d.category] = acc[d.category] || [];
    acc[d.category].push(d);
    return acc;
  }, {});

  // Close gear menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.nav-gear-menu')) setGearOpen(false);
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div style={{
      fontFamily: "'Plus Jakarta Sans', Inter, sans-serif",
      background: 'radial-gradient(circle at top left, #1e1e2f 0%, #0f0f23 100%)',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      color: '#fff'
    }}>
      {/* Navbar */}
      <nav 
  className="navbar"
  style={{
    position: 'relative',
    padding: '1rem 2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '70px',
    background: '#181826',
    borderBottom: '1px solid #2c2c3d'
  }}
>
  {/* Sidebar Toggle (if you have one) */}
  <button className="sidebar-toggle">☰</button>

  {/* Logo (centered) */}
  <div className="nav-logo" style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
    <img src="/images/domainexpansions.png" alt="Logo" />
  </div>

  {/* Desktop Links */}
  <div className="nav-links" style={{ marginLeft: 'auto' }}>
    {['Home', 'Explore', 'About'].map((text, i) => (
      <a key={i} href="#" style={{ color: '#fff', textDecoration: 'none', marginLeft: '1.5rem' }}>
        {text}
      </a>
    ))}
  </div>

  {/* Gear Menu (mobile/tablet) */}
  <div className="nav-gear-menu" style={{ marginLeft: 'auto', position: 'relative' }}>
    <button
      className="gear-button"
      onClick={() => setGearOpen(prev => !prev)}
      style={{
        background: 'none',
        border: 'none',
        color: '#ffca5e',
        fontSize: '1.6rem',
        cursor: 'pointer'
      }}
    >
      ⚙️
    </button>

    {gearOpen && (
      <div
        className="gear-dropdown"
        style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          background: '#1e1e2f',
          border: '1px solid #2c2c3d',
          borderRadius: '8px',
          boxShadow: '0 6px 12px rgba(0,0,0,0.4)',
          padding: '0.5rem 0',
          zIndex: 999
        }}
      >
        {['Home', 'Explore', 'About'].map((text, i) => (
          <a
            key={i}
            href="#"
            className="gear-link"
            style={{
              display: 'block',
              padding: '0.75rem 1rem',
              color: '#cbd5e1',
              textDecoration: 'none'
            }}
          >
            {text}
          </a>
        ))}
      </div>
    )}
  </div>

        {/* Sidebar toggle */}
        <button className="sidebar-toggle" onClick={() => setSidebarOpen(prev => !prev)}>☰</button>
      </nav>

      {/* Layout */}
      <div className="main-layout" style={{ display: 'flex', flex: 1 }}>
        {/* Sidebar */}
        <aside className={`sidebar ${sidebarOpen ? 'open' : 'collapsed'}`} style={{
          width: '260px',
          background: '#181826',
          padding: '2rem 1rem',
          borderRight: '1px solid #2c2c3d',
          overflowY: 'auto'
        }}>
          <h3 style={{
            fontSize: '1.4rem',
            marginBottom: '1rem',
            color: '#ffca5e',
            borderBottom: '2px solid #ffca5e',
            paddingBottom: '0.4rem',
            fontWeight: '600',
            letterSpacing: '0.5px'
          }}>
            Our Communities
          </h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {Object.entries(groupedByAnime)
              .sort(([a], [b]) => a.localeCompare(b))
              .map(([anime, domains]) => (
                <li key={anime} style={{ marginBottom: '1rem' }}>
                  <div onClick={() => toggleAnime(anime)} style={{
                    cursor: 'pointer',
                    fontWeight: 600,
                    color: '#f9fafb',
                    padding: '0.25rem 0',
                    transition: 'color 0.2s ease-in-out'
                  }}>{anime}</div>
                  {expandedAnime[anime] && (
                    <ul style={{ paddingLeft: '1rem', marginTop: '0.5rem' }}>
                      {domains.map((d, idx) => (
                        <li key={idx}>
                          <a href={d.sns} target="_blank" rel="noreferrer" style={{
                            color: '#a5b4fc',
                            textDecoration: 'none',
                            fontSize: '0.9rem'
                          }}>{d.domain}</a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
          </ul>
        </aside>

        {/* Main Content */}
        <main style={{ flex: 1, padding: '3rem', textAlign: 'center' }}>
          {/* Hero Section */}
          <div className="hero" style={{
            backgroundImage: 'url("/images/adnbg.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            padding: '5rem 2rem',
            borderRadius: '16px',
            marginBottom: '3rem',
            boxShadow: '0 6px 20px rgba(0,0,0,0.4)',
            position: 'relative'
          }}>
            <div className="hero-inner" style={{
              backgroundColor: 'rgba(0,0,0,0.6)',
              padding: '2rem',
              borderRadius: '12px'
            }}>
              <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', color: '#fff' }}>
                Find Your Community
              </h1>
              <p style={{ color: '#9ca3af', marginBottom: '2rem' }}>
                Search and mint entertainment-inspired Solana subdomains.
              </p>

              <div className="search-bar" style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                <input
                  type="text"
                  value={query}
                  placeholder="e.g. HiddenLeafVillage.sol"
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  style={{
                    flex: 1,
                    padding: '0.75rem 1rem',
                    fontSize: '1rem',
                    borderRadius: '8px',
                    border: '1px solid #444',
                    background: '#1e1e2f',
                    color: '#fff',
                    outline: 'none'
                  }}
                />
                <button
                  onClick={handleSearch}
                  style={{
                    padding: '0.75rem 1.5rem',
                    fontSize: '1rem',
                    background: 'linear-gradient(to right, #ff66c4, #9d4edd)',
                    color: '#fff',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(255,102,196,0.3)'
                  }}
                >
                  Search
                </button>
              </div>

              {/* Suggestions */}
              {suggestions.length > 0 && (
                <div style={{
                  textAlign: 'left',
                  marginTop: '1rem',
                  maxHeight: '240px',
                  overflowY: 'auto',
                  border: '1px solid #333',
                  borderRadius: '6px',
                  background: '#1e1e2f',
                  position: 'relative'
                }}>
                  <style>{`
                    ::-webkit-scrollbar { width: 8px; }
                    ::-webkit-scrollbar-track { background: #1e1e2f; }
                    ::-webkit-scrollbar-thumb { background: #444; border-radius: 4px; }
                    ::-webkit-scrollbar-thumb:hover { background: #666; }
                  `}</style>
                  {suggestions.map((sug, idx) => (
                    <div key={idx} onClick={() => handleSuggestionClick(sug)} style={{
                      padding: '0.6rem 1rem',
                      borderBottom: '1px solid #333',
                      cursor: 'pointer',
                      color: '#e0e7ff'
                    }}>
                      {sug.domain}
                    </div>
                  ))}
                </div>
              )}

              {/* Result */}
              {result && (
                <div style={{
                  marginTop: '1.5rem',
                  padding: '1rem',
                  background: '#1e1e2f',
                  borderRadius: '8px',
                  border: '1px solid #333',
                  color: '#fff'
                }}>
                  {result === 'not found' ? (
                    <p>❌ Domain not available. Try another.</p>
                  ) : (
                    <p>✅ <strong>{result.domain}</strong> {' '}
                      <a href={result.sns} target="_blank" rel="noreferrer" style={{ color: '#79ffe1' }}>
                        Mint Subdomain
                      </a>
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Promo Cards */}
          <div className="promo-cards" style={{
            marginTop: '2rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
            gap: '1.5rem'
          }}>
            {Object.entries(groupedByCategory).map(([category, entries]) => (
              <div key={category} style={{
                background: '#181826',
                borderRadius: '12px',
                padding: '1rem',
                textAlign: 'left',
                border: '1px solid #333',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
              }}>
                <img src="/images/pagoda.png" alt={category} style={{
                  width: '100%',
                  height: '140px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  marginBottom: '1rem'
                }} />
                <h3 style={{ fontSize: '1.1rem', marginBottom: '0.5rem', color: '#ff66c4' }}>{category}</h3>
                <ul style={{ padding: 0, listStyle: 'none', color: '#cbd5e1', fontSize: '0.9rem' }}>
                  {entries.slice(0, 3).map((d, idx) => (
                    <li key={idx}>
                      <a href={d.sns} target="_blank" rel="noreferrer" style={{ color: '#a5b4fc', textDecoration: 'none' }}>{d.domain}</a>
                    </li>
                  ))}
                </ul>
                {entries.length > 3 && (
                  <a href={`/${encodeURIComponent(category)}`} style={{
                    display: 'inline-block',
                    marginTop: '0.75rem',
                    fontSize: '0.85rem',
                    color: '#7dd3fc',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  }}>
                    Show More →
                  </a>
                )}
              </div>
            ))}
          </div>

        </main>
      </div>
    </div>
  );
}

export default App;
